// 官网后端接口地址（后端固定 10088；前端静态页走 80/443）
// 本地调试（本机后端未开 SSL 时用）
// export const baseUrl = 'http://localhost:10088'

// 线上（与后端 HTTPS 一致，避免 HTTPS 页面请求 HTTP 被浏览器拦截）
export const baseUrl = 'https://www.hfqsyl.com:10088'
